import BoardLayout from "../../components/Board/Boardlayout";
import MessageItem from "../../components/FormsV2/MessageItem/MessageItem";
import React from "react";
import ReactDOM from "react-dom";
import r2wc from "react-to-webcomponent";
import { withAppProviders } from "../../appProviders";
import { store } from "../../appRedux/store/Store";
import { setBoard, setSheet, setUserBoards } from "../../appRedux/actions/Boards";

class ExtendedBoardLayoutWebComponent extends r2wc(withAppProviders(BoardLayout), React, ReactDOM) {
   async connectedCallback() {
      try {
         const boardsBase64 = this.getAttribute("boards-base64");
         if (!boardsBase64) {
            throw new Error("Board data is required");
         }

         const binString = atob(boardsBase64);
         const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0));
         const boards = JSON.parse(new TextDecoder().decode(bytes));

         if (!boards || !Array.isArray(boards) || boards.length === 0) {
            throw new Error("Invalid board data");
         }

         store.dispatch(setUserBoards(boards));

         const boardId = +this.getAttribute("board-id");
         const sheetId = +this.getAttribute("sheet-id");

         const board = boards.find((b) => b.id === boardId) || boards[0];

         if (!board) {
            throw new Error("No matching board found");
         }

         let sheet = board.sheets.find((sheet) => !sheetId || sheet.id === sheetId);

         if (!sheet) {
            throw new Error("No sheets found for the given board");
         }

         store.dispatch(setBoard(board));
         store.dispatch(setSheet(parseInt(sheet.id)));
      } catch (error) {
         console.error("Failed to initialize board layout:", error);
         throw error;
      }

      await super.connectedCallback();
   }
}

customElements.define("legacy-board-layout", ExtendedBoardLayoutWebComponent);

customElements.define(
   "legacy-message-item",
   r2wc(withAppProviders(MessageItem, { includeRouter: false }), React, ReactDOM, {
      props: { instanceId: "string", hideComments: "boolean" },
   }),
);
